import React from "react";
import CookieConsent from "react-cookie-consent";
import "./cookie.css";

const Cookie = () => {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText="Bestätigen"
        cookieName="modernCookieConsent"
        containerClasses="cookie-container"
        contentClasses="cookie-content"
        buttonClasses="cookie-button"
        expires={150}
      >
        <span>
        Diese Website verwendet Cookies und Analytics, um die Benutzererfahrung zu verbessern.{" "}
          <a href="/datenschutz" className="cookie-link">
            Mehr erfahren
          </a>
        </span>
      </CookieConsent>
    </div>
  );
};

export default Cookie;
